import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_API_URL || 'https://communicationprodapi.earlyjobs.ai/api';

export interface PerformanceData {
  userId: string;
  name: string;
  score: number;
  trend: 'up' | 'down' | 'stable';
  hirings: number; // This is the main metric displayed (total joinings)
  joinings: number;
  selections: number;
  walkins: number;
  role: string;
  franchiseId?: string;
  franchiseName?: string;
}

export interface CategoryData {
  title: string;
  performers: PerformanceData[];
}

export interface LeaderboardResponse {
  status: string;
  data: {
    period: string;
    field: string;
    categories: CategoryData[];
    generatedAt: string;
  };
}

export interface UserPerformanceResponse {
  status: string;
  data: {
    userId: string;
    username: string;
    role: string;
    franchiseId?: string;
    joinings: number;
    selections: number;
    walkins: number;
    currentPeriodScore: number;
    previousPeriodScore: number;
    trend: 'up' | 'down' | 'stable';
  };
}

export interface MetadataResponse {
  status: string;
  data: {
    periods: string[];
    fields: string[];
    availableCategories: string[];
  };
}

/**
 * Get leaderboard data
 */
export const getLeaderboard = async (
  period: string = 'weekly',
  field: string = 'all',
  limit: number = 10
): Promise<LeaderboardResponse> => {
  const token = localStorage.getItem('accessToken');
  const response = await axios.get(`${API_BASE_URL}/leaderboard`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      period,
      field,
      limit,
    },
  });
  return response.data;
};

/**
 * Get current user's performance
 */
export const getMyPerformance = async (
  period: string = 'weekly',
  field: string = 'all'
): Promise<UserPerformanceResponse> => {
  const token = localStorage.getItem('accessToken');
  const response = await axios.get(`${API_BASE_URL}/leaderboard/my-performance`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      period,
      field,
    },
  });
  return response.data;
};

/**
 * Get specific user's performance
 */
export const getUserPerformance = async (
  userId: string,
  period: string = 'weekly',
  field: string = 'all'
): Promise<UserPerformanceResponse> => {
  const token = localStorage.getItem('accessToken');
  const response = await axios.get(`${API_BASE_URL}/leaderboard/user/${userId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: {
      period,
      field,
    },
  });
  return response.data;
};

/**
 * Get leaderboard metadata
 */
export const getLeaderboardMetadata = async (): Promise<MetadataResponse> => {
  const token = localStorage.getItem('accessToken');
  const response = await axios.get(`${API_BASE_URL}/leaderboard/metadata`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

